// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"165e20f5","11":"b0f8793a","165":"31d5d8b0","191":"09e030bc","335":"42402c9b","406":"4a653eb0","489":"486bd676","564":"a5bf3955","615":"cb6d2a6e","658":"5a11a382","796":"eb703adf","908":"d4df4cd2","947":"92e9180b"}[chunkId] + ".chunk.js";
};